/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageNodeMini
 */
export interface StorageNodeMini {
    /**
     * 
     * @type {number}
     * @memberof StorageNodeMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof StorageNodeMini
     */
    name?: string;
    /**
     * For communication between nodes only
     * @type {string}
     * @memberof StorageNodeMini
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof StorageNodeMini
     */
    type?: StorageNodeMiniTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum StorageNodeMiniTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

export function StorageNodeMiniFromJSON(json: any): StorageNodeMini {
    return StorageNodeMiniFromJSONTyped(json, false);
}

export function StorageNodeMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageNodeMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function StorageNodeMiniToJSON(value?: StorageNodeMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': value.address,
        'type': value.type,
    };
}


